// Tenant-level settings cache. The paid-until chip threshold needs to be
// known on every render of the customers list, so we fetch once and stash.

import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { api } from './api.js';

interface TenantSettings {
  paidUntilWarningDays: number;
}

const DEFAULTS: TenantSettings = { paidUntilWarningDays: 10 };

const SettingsContext = createContext<TenantSettings>(DEFAULTS);

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<TenantSettings>(DEFAULTS);

  useEffect(() => {
    api<TenantSettings>('/settings')
      .then((s) => setSettings(s))
      .catch(() => {
        // Stick with defaults — the chip still renders.
      });
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSettings(): TenantSettings {
  return useContext(SettingsContext);
}
